export default "__VITE_ASSET__D$SgOiOS__"